import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export function AddSupplierButton(
  handleOpenAddSupplierSampleRequestModal,
  supplierButtonDisabled
) {
  return (
    <Grid item>
      <Button
        size="small"
        variant="contained"
        disabled={supplierButtonDisabled}
        sx={{
          padding: "10px 20px",
          mr: "20px",
          fontSize: "14px",
          backgroundColor: "#c7ab79",
        }}
        onClick={() => handleOpenAddSupplierSampleRequestModal()}
      >
        Add Supplier
      </Button>
    </Grid>
  );
}
